// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-promotion[data-v-29d56957]{border-color:var(--bs-warning)}", "",{"version":3,"sources":["webpack://./src/main/webapp/WEB-INF/views/showcase/components/InternetAndMobileCard.vue"],"names":[],"mappings":"AACA,iCACI,8BAAA","sourcesContent":["\n.card-promotion {\n    border-color: var(--bs-warning);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
